/**
 * TW Carousel Group — horizontal scroll progress indicator (Figma CRO bar).
 * Thumb size and position reflect viewport vs scrollable width and scrollLeft.
 */

(function () {
  'use strict';

  /** @type {WeakSet<Element>} */
  const initialized = new WeakSet();

  /**
   * @param {Element} root
   */
  function bindCarouselProgress(root) {
    if (initialized.has(root)) {
      return;
    }

    const grid = root.querySelector('.tw-carousel-group__grid');
    const progress = root.querySelector('[data-tw-carousel-progress]');
    const thumb = root.querySelector('[data-tw-carousel-progress-thumb]');

    if (!grid || !progress || !thumb) {
      return;
    }

    initialized.add(root);

    /** @type {number | null} */
    let scheduledFrame = null;

    const update = () => {
      const scrollLeft = grid.scrollLeft;
      const scrollWidth = grid.scrollWidth;
      const clientWidth = grid.clientWidth;
      const maxScroll = Math.max(0, scrollWidth - clientWidth);

      if (maxScroll < 1) {
        progress.hidden = true;
        return;
      }

      progress.hidden = false;

      const thumbW = (clientWidth / scrollWidth) * 100;
      const leftPct = (scrollLeft / maxScroll) * (100 - thumbW);

      thumb.style.width = `${thumbW}%`;
      thumb.style.left = `${leftPct}%`;
    };

    const scheduleUpdate = () => {
      if (scheduledFrame !== null) return;
      scheduledFrame = requestAnimationFrame(() => {
        scheduledFrame = null;
        update();
      });
    };

    grid.addEventListener('scroll', scheduleUpdate, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(scheduleUpdate);
      ro.observe(grid);
    } else {
      window.addEventListener('resize', scheduleUpdate, { passive: true });
    }

    scheduleUpdate();
  }

  /**
   * @param {ParentNode} [container]
   */
  function initTwCarouselGroups(container) {
    const root = container || document;
    root.querySelectorAll('[data-tw-carousel-group]').forEach(bindCarouselProgress);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initTwCarouselGroups(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (target instanceof HTMLElement) {
      initTwCarouselGroups(target);
    }
  });
})();
